'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _ = require('lodash');
var AclService = require('js-acl');

var _require = require('@wix/communities-universal/dist/src/constants/appsConfig'),
    BLOG_APP_ID = _require.BLOG_APP_ID;

var USER_PRIVACY_STATUS_PRIVATE = 'PRIVATE';
var USER_PRIVACY_STATUS_PUBLIC = 'PUBLIC';

var ROLE_GUEST = 'guest';
var ROLE_USER = 'user';
var ROLE_OPEN_BLOG_WRITER = 'open-blog-writer';
var ROLE_WRITER = 'writer';
var ROLE_EDITOR = 'editor';
var ROLE_OWNER = 'owner';
var ROLE_SERVICE = 'service';

// TODO: remove check for allowed blog roles when user service client constructs permissions in appData correctly
var ALLOWED_BLOG_ROLES = [ROLE_GUEST, ROLE_USER, ROLE_OPEN_BLOG_WRITER, ROLE_WRITER, ROLE_EDITOR, ROLE_OWNER, ROLE_SERVICE];

var RESOURCE_BLOG = 'blog';
var RESOURCE_CATEGORY = 'category';
var RESOURCE_POST = 'post';
var RESOURCE_COMMENT = 'comment';
var RESOURCE_MEMBER = 'member';
var RESOURCE_RCE_SETTINGS = 'rceSettings';
var RESOURCE_FILE = 'file';
var RESOURCE_TAG = 'tag';

/*
 * PermissionsChecker provides 2 types of checks:
 * - can: this checks if a role can do an action on resource
 * - canSee: this checks if a role can see an action on resource (know that there is an ability to do such action)
 *
 * They are mostly identical, but for some resources action they differ. For example,
 * everyone can see like on post, but only logged in, non blocked, non private can like.
 *
 * If a role can do an action on resource, this means he can also see.*/
var permissionsChecker = function permissionsChecker() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$isMemberAppInsta = _ref.isMemberAppInstalled,
      isMemberAppInstalled = _ref$isMemberAppInsta === undefined ? false : _ref$isMemberAppInsta,
      _ref$isMemberAreaInst = _ref.isMemberAreaInstalled,
      isMemberAreaInstalled = _ref$isMemberAreaInst === undefined ? false : _ref$isMemberAreaInst,
      _ref$isSocialSharingE = _ref.isSocialSharingEnabled,
      isSocialSharingEnabled = _ref$isSocialSharingE === undefined ? true : _ref$isSocialSharingE,
      _ref$isCommentsEnable = _ref.isCommentsEnabled,
      isCommentsEnabled = _ref$isCommentsEnable === undefined ? true : _ref$isCommentsEnable,
      _ref$isAnonymousLikes = _ref.isAnonymousLikesEnabled,
      isAnonymousLikesEnabled = _ref$isAnonymousLikes === undefined ? true : _ref$isAnonymousLikes;

  var user = arguments[1];
  var resolve = arguments[2];

  var hasMemberFunctions = isMemberAppInstalled || isMemberAreaInstalled;

  function setupAcl(acl, isSee) {
    // Roles
    acl.addRole('guest');
    acl.addRole('user', 'guest');
    acl.addRole('open-blog-writer', 'user');
    acl.addRole('writer', 'open-blog-writer');
    acl.addRole('editor', 'writer');
    acl.addRole('owner', 'editor');
    acl.addRole('service', 'owner');

    // Resources
    acl.addResource('blog');
    acl.addResource('category');
    acl.addResource('tag');
    acl.addResource('post');
    acl.addResource('comment', 'post');
    acl.addResource('member');
    acl.addResource('author');
    acl.addResource('settings');
    acl.addResource('analytics');
    acl.addResource('rceSettings');
    acl.addResource('file');

    // Guest
    acl.allow('guest', 'blog', 'read');
    acl.allow('guest', 'category', 'read');
    acl.allow('guest', 'tag', 'read');
    acl.allow('guest', 'post', 'read', resourceIsPublished);
    acl.allow('guest', 'post', 'read-comment', and(resourceIsPublished, resourceIsFree));

    if (isSocialSharingEnabled) {
      acl.allow('guest', 'post', 'share', resourceIsPublished);
      acl.allow('guest', 'comment', 'share');
    }

    if (isSee) {
      acl.allow('guest', 'post', 'like', resourceIsPublished);
      acl.allow('guest', 'comment', 'like');
    } else if (isAnonymousLikesEnabled) {
      acl.allow('guest', 'post', 'like', and(resourceIsPublished, not(userIsPrivate)));
      acl.allow('guest', 'comment', 'like', and(afterResolve(resourceIsPublished), not(userIsPrivate)));
    }

    // User
    acl.allow('user', 'blog', 'subscribe', not(userIsPrivate));
    acl.allow('user', 'post', 'like', isSee ? resourceIsPublished : and(resourceIsPublished, not(userIsPrivate)));

    if (hasMemberFunctions) {
      acl.allow('user', 'post', 'subscribe', isSee ? resourceIsPublished : and(resourceIsPublished, not(userIsPrivate)));
      acl.allow('user', 'post', 'report', isSee ? and(resourceIsPublished, not(userIsResourceOwner), not(resourceOwnerHasRoles('owner'))) : and(resourceIsPublished, not(userIsResourceOwner), not(resourceOwnerHasRoles('owner')), not(userIsPrivate)));
    }

    if (isCommentsEnabled) {
      acl.allow('user', 'post', 'create-comment', isSee ? and(resourceIsPublished, not(resourceHasCommentsDisabled), or(resourceIsFree, canAccessPaidResource)) : and(resourceIsPublished, not(resourceHasCommentsDisabled), not(userIsPrivate), or(resourceIsFree, canAccessPaidResource)));
    }
    acl.allow('user', 'post', 'read-comment', and(resourceIsPublished, or(resourceIsFree, canAccessPaidResource)));

    if (hasMemberFunctions) {
      acl.allow('user', 'comment', 'report', isSee ? and(not(userIsResourceOwner), not(resourceOwnerHasRoles('owner'))) : and(not(userIsResourceOwner), not(resourceOwnerHasRoles('owner')), not(userIsPrivate)));
    }

    acl.allow('user', 'comment', 'edit', isSee ? userIsResourceOwner : and(userIsResourceOwner, not(userIsPrivate)));
    acl.allow('user', 'comment', 'delete', userIsResourceOwner);
    acl.allow('user', 'comment', 'like', isSee ? afterResolve(resourceIsPublished) : and(afterResolve(resourceIsPublished), not(userIsPrivate)));
    acl.allow('user', 'member', 'subscribe', and(not(userIsResource), not(userIsPrivate)));
    acl.allow('user', 'member', 'list');
    acl.allow('user', 'member', 'edit', userIsResource);
    acl.allow('user', 'member', 'delete', and(userIsResource, not(resourceHasRoles('owner'))));

    // OpenBlogWriter
    acl.allow('open-blog-writer', 'post', 'create');
    acl.allow('open-blog-writer', 'post', 'read', or(userIsResourceOwner, resourceIsPublished));
    acl.allow('open-blog-writer', 'post', 'read-comment', or(userIsResourceOwner, and(resourceIsPublished, or(resourceIsFree, canAccessPaidResource))));
    acl.allow('open-blog-writer', 'post', 'duplicate', userIsResourceOwner);
    acl.allow('open-blog-writer', 'post', 'publish', userIsResourceOwner);
    acl.allow('open-blog-writer', 'post', 'delete', userIsResourceOwner);
    acl.allow('open-blog-writer', 'post', 'edit', userIsResourceOwner);
    acl.allow('open-blog-writer', 'post', 'preview', userIsResourceOwner);
    acl.allow('open-blog-writer', 'post', 'search-owned');
    acl.deny('open-blog-writer', 'post', 'report', userIsResourceOwner);
    acl.deny('open-blog-writer', 'post', 'share');

    acl.allow('open-blog-writer', 'comment', 'delete', afterResolve(userIsResourceOwner));
    acl.deny('open-blog-writer', 'comment', 'report', afterResolve(userIsResourceOwner));
    acl.deny('open-blog-writer', 'comment', 'share');

    acl.allow('open-blog-writer', 'rceSettings', 'edit');

    acl.allow('open-blog-writer', 'file', 'upload');

    // Writer
    acl.allow('writer', 'post', 'edit-post-settings', or(userIsResourceOwner, isNewResource));
    acl.allow('writer', 'post', 'toggle-seo', or(userIsResourceOwner, isNewResource));
    if (isCommentsEnabled) {
      acl.allow('writer', 'post', 'toggle-comments', or(userIsResourceOwner, isNewResource));
    }

    if (isSocialSharingEnabled) {
      acl.allow('writer', 'post', 'share', resourceIsPublished);
      acl.allow('writer', 'comment', 'share');
    }

    acl.allow('writer', 'tag', ['read', 'create']);

    // Editor
    acl.allow('editor', 'author', 'create');
    acl.allow('editor', 'blog', 'reorder-categories');
    acl.allow('editor', 'category', ['read', 'create', 'create-post', 'edit', 'delete']);
    acl.allow('editor', 'tag', ['read', 'create', 'edit', 'delete']);
    acl.allow('editor', 'comment', 'delete');
    acl.allow('editor', 'post', ['read', 'subscribe', 'create', 'edit', 'edit-post-settings', 'publish', 'delete', 'pin', 'read-comment', 'search', 'toggle-featured', 'toggle-seo', 'change-owner', 'duplicate', 'preview']);
    if (isCommentsEnabled) {
      acl.allow('editor', 'post', ['toggle-comments', 'create-comment']);
    }

    acl.deny('editor', 'post', 'report');
    acl.deny('editor', 'comment', 'report');
    acl.deny('editor', 'comment', 'edit', not(userIsResourceOwner));

    // Owner
    acl.allow('owner', 'blog', 'edit');
    acl.allow('owner', 'post', 'read-comment');
    acl.allow('owner', 'member', 'delete', not(resourceHasRoles('owner')));
    acl.allow('owner', 'member', 'promote', and(not(resourceIsBlocked), not(resourceHasRoles('owner'))));
    acl.allow('owner', 'member', 'delete', not(resourceHasRoles('owner')));
    acl.allow('owner', 'settings', 'edit');
    acl.allow('owner', 'analytics', 'view');
    acl.allow('owner', 'author', 'create');

    // Service
    acl.allow('service', 'post', 'reblog');
    acl.allow('service', 'post', 'read-comment');

    return acl;
  }

  var acl = setupAcl(new AclService());
  var aclSee = setupAcl(new AclService(), hasMemberFunctions);

  var wrapped = {
    ROLE_GUEST: ROLE_GUEST,
    ROLE_USER: ROLE_USER,
    ROLE_WRITER: ROLE_WRITER,
    ROLE_EDITOR: ROLE_EDITOR,
    ROLE_OWNER: ROLE_OWNER,
    RESOURCE_BLOG: RESOURCE_BLOG,
    RESOURCE_CATEGORY: RESOURCE_CATEGORY,
    RESOURCE_POST: RESOURCE_POST,
    RESOURCE_COMMENT: RESOURCE_COMMENT,
    RESOURCE_MEMBER: RESOURCE_MEMBER,

    resourcify: resourcify,
    setUserIdentity: function setUserIdentity(user) {
      var identity = _extends({}, user);
      var role = _.get(identity, 'appStore[' + BLOG_APP_ID + '].permissions.role', ROLE_GUEST);
      if (!_.includes(ALLOWED_BLOG_ROLES, role)) {
        role = identity.isOwner ? 'owner' : 'user';
      }
      if (_.get(identity, 'isBlocked')) {
        role = ROLE_GUEST;
      }

      // when member area not installed, we don't care about user being private.
      if (!isMemberAreaInstalled) {
        identity.privacyStatus = USER_PRIVACY_STATUS_PUBLIC;
      }
      acl.setUserIdentity(rolify(identity, role));
      aclSee.setUserIdentity(rolify(identity, role));
    },
    getUserIdentity: function getUserIdentity() {
      return acl.getUserIdentity();
    },
    can: function can(resource, permission) {
      return acl.can(resource, permission);
    },
    canSee: function canSee(resource, permission) {
      return aclSee.can(resource, permission);
    }
  };
  wrapped.setUserIdentity(user);
  return wrapped;

  function not(fn) {
    var _this = this;

    return function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return !fn.apply(_this, args);
    };
  }

  function and() {
    var _this2 = this;

    for (var _len2 = arguments.length, fns = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      fns[_key2] = arguments[_key2];
    }

    return function () {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _.every(fns, function (fn) {
        return fn.apply(_this2, args);
      });
    };
  }

  function or() {
    var _this3 = this;

    for (var _len4 = arguments.length, fns = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      fns[_key4] = arguments[_key4];
    }

    return function () {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _.some(fns, function (fn) {
        return fn.apply(_this3, args);
      });
    };
  }

  function userIsResource(user, resource) {
    return user._id === resource._id;
  }

  function userIsResourceOwner(user, resource) {
    return resource.ownerSiteMemberId ? user.siteMemberId === resource.ownerSiteMemberId : user._id === resource.ownerId;
  }

  function userIsPrivate(user) {
    return user.privacyStatus === USER_PRIVACY_STATUS_PRIVATE;
  }

  function resourceHasCommentsDisabled(user, resource) {
    return resource.isCommentsDisabled;
  }

  function resourceHasRoles() {
    for (var _len6 = arguments.length, roles = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      roles[_key6] = arguments[_key6];
    }

    return function (user, resource) {
      return _.includes(roles, _.get(resource, 'appStore[' + BLOG_APP_ID + '].permissions.role'));
    };
  }

  function resourceOwnerHasRoles() {
    for (var _len7 = arguments.length, roles = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      roles[_key7] = arguments[_key7];
    }

    return function (user, resource) {
      return _.includes(roles, _.get(resource, 'owner.appStore[' + BLOG_APP_ID + '].permissions.role'));
    };
  }

  function resourceIsBlocked(user, resource) {
    return resource.isBlocked;
  }

  function resourceIsPublished(user, resource) {
    return resource.status === 'published';
  }

  function resourceIsFree(user, resource) {
    return _.isEmpty(resource.paidPlansGroupIds);
  }

  // returns true on no resource passed. Enables reusing the same permission on create and edit post
  function isNewResource(user, resource) {
    return typeof resource === 'string'; // returns resource name, e.g. 'post'
  }

  function canAccessPaidResource(user, resource) {
    return Boolean(_.intersection(user.paidPlansGroupIds, resource.paidPlansGroupIds).length);
  }

  function afterResolve(fn) {
    return function (user, resource, permission) {
      return fn(user, resolve(resource), permission);
    };
  }

  function rolify(obj, role) {
    return _extends({}, obj, { getRoles: function getRoles() {
        return [role];
      } });
  }
};

var resourcify = function resourcify(obj, resource) {
  return obj ? _extends({}, obj, { getResourceId: function getResourceId() {
      return resource;
    } }) : resource;
};

module.exports = {
  ROLE_GUEST: ROLE_GUEST,
  ROLE_USER: ROLE_USER,
  ROLE_WRITER: ROLE_WRITER,
  ROLE_EDITOR: ROLE_EDITOR,
  ROLE_OWNER: ROLE_OWNER,
  ALLOWED_BLOG_ROLES: ALLOWED_BLOG_ROLES,
  RESOURCE_BLOG: RESOURCE_BLOG,
  RESOURCE_CATEGORY: RESOURCE_CATEGORY,
  RESOURCE_POST: RESOURCE_POST,
  RESOURCE_COMMENT: RESOURCE_COMMENT,
  RESOURCE_MEMBER: RESOURCE_MEMBER,
  RESOURCE_RCE_SETTINGS: RESOURCE_RCE_SETTINGS,
  RESOURCE_FILE: RESOURCE_FILE,
  RESOURCE_TAG: RESOURCE_TAG,
  resourcify: resourcify,
  permissionsChecker: permissionsChecker
};